import queryString from "query-string";
import services from "../../../../services";
import $ from 'jquery';

let data = [];

const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    item.ProductID = generateId(data);
    item.inEdit = false;
    item.IDAutoDetalhe = 0;
    item.Columns = [];
    data.unshift(item);
    return data;
};

export const deleteAll = () => {
    data = [];
    return data;

};
export const dataGet10 = async () => {
    return data;
};

// export const getItems10 = async () =>  {
//     console.log("services10")   
//     return data
// };
export const getItems10 = async () =>  {
    if(window.location.search != ""){
        var queryParams = queryString.parse(window.location.search)
        var  token = queryParams.idAuto
        var  dataToken = {"idAuto": token}
        var Detalhes = await services.apiCall.requestApi(
            "/Fiscalizacao/GetAutoDetalhe",
            dataToken,
            "get"
        ); 
            for (let i = 0; i < Detalhes.autoGridGranel.length ; i++) {
                var EntidadesInstEng = Detalhes.autoGridGranel[i].idAgenteEconomico;
                var idContaCorrenteEngarrafado = Detalhes.autoGridEngarrafado[i].idContaCorrente == 2 ? 'Outros' : Detalhes.autoGridEngarrafado[i].idContaCorrente == 1 ? 'ProdutosSemConta' : Detalhes.autoGridEngarrafado[i].idContaCorrente;
                var idProdutoSemContaEnga = Detalhes.autoGridGranel[i].produtosSemConta;
                var idTipoVasilha = Detalhes.autoGridGranel[i].idTipoVasilha;
                var idVasilha = Detalhes.autoGridGranel[i].idVasilha;
                var quantidadeAferida = Detalhes.autoGridGranel[i].quantidadeAferida;
                var quantidadeFinal = Detalhes.autoGridGranel[i].quantidadeFinal;
                var falta = Detalhes.autoGridGranel[i].falta;
                var altura = Detalhes.autoGridGranel[i].altura;
                var falta = Detalhes.autoGridGranel[i].falta;
                var observacoes = Detalhes.autoGridGranel[i].observacoes;
                var tipoVasilha =  Detalhes.autoGridGranel[i].tipoVasilha;
                var idTipoVasilha =  Detalhes.autoGridGranel[i].idTipoVasilha;
                var idVasilha = Detalhes.autoGridGranel[i].idVasilha;
                var numeroVasilha = Detalhes.autoGridGranel[i].numeroVasilha;
                var capacidadeCalculada = Detalhes.autoGridGranel[i].capacidadeCalculada;
                var idAutoDetalhe1 = Detalhes.autoGridGranel[i].idAutoDetalhe;
                var ano = Detalhes.autoGridGranel[i].anoGranel;
                var idcor = Detalhes.autoGridGranel[i].idCorGranel
                data.push({ 
                    idEntidadesInst : EntidadesInstEng,
                    EntidadesInst : EntidadesInstEng,
                    idContaCorrenteEng: idContaCorrenteEngarrafado,
                    idProdutosSemConta : idProdutoSemContaEnga,
                    Tipo_Vasilha : {text: tipoVasilha , value: idTipoVasilha},
                    N_Vasilha :  {text: numeroVasilha, value: idVasilha, CapacidadeCalculada: capacidadeCalculada},
                    Quantidade_aferida : quantidadeAferida,
                    QuantidadeApurada : quantidadeFinal,
                    Falta: falta,
                    Altura: altura,
                    Observacoes: observacoes,
                    idAutoDetalhe: idAutoDetalhe1,
                    Ano: ano,
                    idCor: idcor,
                    Discontinued: false,
                    Columns: [],
                    inEdit: false,
                    ProductID: i + 1,
                })
            }
            return data;
        
    }else{
         return data
    }
    
};
export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
